export default ({ app, store }) => {
  app.router.beforeEach((to, from, next) => {
    // Commit on every navigation, not only on a hit: leaving a stale hint in
    // place is what makes the *next* page 404, so each navigation either claims
    // the hint for its own slug or clears it.
    if (to.name === 'slug' && window.__productSlugs?.has(to.params.slug)) {
      store.commit('SLUG_HINT/SET', to.params.slug)
    } else {
      store.commit('SLUG_HINT/CLEAR')
    }
    next()
  })
}
